import {Modal, Form, Button, Row, Col} from 'react-bootstrap'
import {useState, useMemo, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import API from '../helpers/api';
import moment from 'moment';

export default function AdvancedSearchModal({close}){
    const dispatch = useDispatch();
    const api = useMemo(() => new API({dispatch}), []);
    const [searchParams, setSearchParams] = useState({
        firstName: '',
        surname: '',
        emailAddress: '',
        phoneNumber: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSearchParams(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            let params = {};
            Object.keys(searchParams).forEach(key => {
                if (searchParams[key] && searchParams[key].trim() !== '') {
                    params[key] = searchParams[key].trim();
                }
            });

            const response = await api.searchAccounts(params);
            // Handle the response as needed
            console.log("Search Results: ", response);
            close();
        } catch (error) {
            alert('Error searching accounts');
            console.error('Error searching accounts:', error);
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <Modal show onHide={close} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Advanced Account Search</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="firstName">
                                <Form.Label>First Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="firstName"
                                    value={searchParams.firstName}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col>
                            <Form.Group controlId="surname">
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="surname"
                                    value={searchParams.surname}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="emailAddress">
                                <Form.Label>Email Address</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="emailAddress"
                                    value={searchParams.emailAddress}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="phoneNumber">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="phoneNumber"
                                    value={searchParams.phoneNumber}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                   

                    <div className="mt-3 text-center">
                        <Button variant="secondary" onClick={close} disabled={isSubmitting} className="me-2">
                            Cancel
                        </Button>
                        <Button type="submit" disabled={isSubmitting}>
                            {isSubmitting ? 'Searching...' : 'Search'}
                        </Button>
                    </div>

                </Form>
            </Modal.Body>
        </Modal>
    )

}
